module.exports = __webpack_public_path__ + "img/lvshiguanli.3129068e.png";